import React from 'react';
import { Breadcrumbs, Btn, H5 } from '../../../AbstractElements';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import PermissionsTable from './PermissionsTable';
import { Link } from 'react-router-dom';

const Permissions = () => {
  return (
    <>
      <Breadcrumbs mainTitle="Permissions" title="Permissions" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <H5>Permissions</H5>
                <Link to="/permissions/new">
                  <Btn color="primary">New permission</Btn>
                </Link>
              </CardHeader>
              <CardBody>
                <PermissionsTable />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Permissions;
